import { render } from "./volume-based-price-list.vue?vue&type=template&id=1d46f9ea"
import script from "./volume-based-price-list.vue?vue&type=script&lang=js"
export * from "./volume-based-price-list.vue?vue&type=script&lang=js"

import "./volume-based-price-list.vue?vue&type=style&index=0&id=1d46f9ea&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__